<template>
  <div id="watershed-view">
    <div v-if="vis === '3d'" id="view-3d"></div>
    <img v-else :alt="imageTitle" :title="imageTitle" :src="imgSrc" />
    <div v-if="vis === '3d' && !showInfo" class="info-btn">
      <button class="bounce" @click="showInfo = true">i</button>
    </div>
    <div class="vis-selector">
      <a v-if="vis !== '2d'" href="#" @click.prevent="vis = '2d'">2D</a>
      <span v-else>2D</span> /

      <span v-if="data3D !== null">
        <a v-if="vis !== '3d'" href="#" @click.prevent="vis = '3d'">3D</a>
        <span v-else>3D</span>
      </span>
      <span v-else>
        <fa icon="spinner" spin />
      </span>

    </div>
    <InfoOverlay :show.sync="showInfo">
      <h2>Controles:</h2>
      <ul>
        <li>Botón izquierdo del mouse para girar,</li>
        <li>botón derecho del mouse para desplazar,</li>
        <li>rueda del ratón para hacer zoom.</li>
      </ul>
    </InfoOverlay>
  </div>
</template>

<script>
import Vue from 'vue';
import Q3D from '@/lib/Qgis2threejs';
import InfoOverlay from '@/components/InfoOverlay.vue';

export default {
  name: 'WatershedView',

  components: {
    InfoOverlay,
  },

  props: {
    watershedId: {
      required: true,
    },

    title: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      vis: '2d',
      showInfo: false,
      app3D: null,
      data3D: null,
    };
  },

  computed: {
    imgSrc() {
      return `data/${this.watershedId}/cuenca.png`;
    },

    imageTitle() {
      return `Distribución de rangos altitudinales para la cuenca ${this.title}`;
    },
  },

  mounted() {
    this.load3DData();
  },

  watch: {
    vis() {
      if (this.vis === '3d') {
        Vue.nextTick(() => {
          this.show3D();
        });
      } else if (this.vis === '2d') {
        this.showInfo = false;
        this.app3D = null;
      }
    },

    watershedId() {
      this.vis = '2d';
      this.data3D = null;
      this.load3DData();
    },
  },

  methods: {
    load3DData() {
      Q3D.Application.loadFile(`data/${this.watershedId}/scene.json`, 'json', (obj) => {
        this.data3D = obj;
      });
    },

    show3D() {
      this.app3D = new Q3D.Application();

      const container = document.getElementById('view-3d');

      this.app3D.init(container);
      this.app3D.scene.loadJSONObject(this.data3D);
      this.app3D.start();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

$vis-selector-margin: 20px;
$vis-selector-padding: 5px;

#watershed-view {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: $color-clear;

  #view-3d, img {
    width: 100%;
    height: 100%;
    border-radius: $border-radius;
  }

  .vis-selector {
    position: absolute;
    right: $vis-selector-margin;
    bottom: $vis-selector-margin;
    display: inline-block;
    padding: $vis-selector-padding;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 3px;
  }

  .info-btn {
    display: inline-block;
    position: absolute;

    top: $info-btn-margin;
    right: $info-btn-margin;

    button {
      border: none;
      background: $color-blue;
      width: $info-btn-size;
      height: $info-btn-size;
      border-radius: 20px;
      line-height: $info-btn-size;
      color: #fff;
      font-family: "Times New Roman", Times, serif;
      font-size: 28px;
      font-weight: bold;
    }
  }
}
</style>
